<app-tabs>
  <app-user-analytics></app-user-analytics>
  <app-catalogue-analytics></app-catalogue-analytics>
  <app-product-analytics></app-product-analytics>
</app-tabs>
